import React from "react"

interface Props {
     showInfo: boolean
     setShowInfo: (val: boolean) => void
}

const InstructionStrip = ({ showInfo, setShowInfo }: Props) => (
     <div className="mb-6">
          <div
               className="d-flex align-items-center justify-content-between bg-light-info rounded px-5 py-4 border border-info border-dashed cursor-pointer"
               onClick={() => setShowInfo(!showInfo)}
          >
               <div className="d-flex align-items-center">
                    <i className="fas fa-info-circle text-info fs-4 me-3"></i>
                    <span className="text-gray-800 fs-6 fw-bold">Instructions relatives au dépôt</span>
               </div>
               <i className={`fas ${showInfo ? "fa-chevron-up" : "fa-chevron-down"} text-info fs-7 transition-all`}></i>
          </div>
          {showInfo && (
               <div className="mt-2 px-7 py-5 bg-body border border-secondary border-opacity-25 rounded shadow-sm fs-5 text-gray-700 transition-all">
                    <p className="mb-3">Vous pouvez déposer une facture de frais associée à vos justificatifs. Merci de scanner l'ensemble au format PDF.</p>
                    <p className="mb-0 fw-semibold text-gray-800">Si les frais sont inclus dans votre facture globale de prestation, déposez-la uniquement à l'étape suivante.</p>
               </div>
          )}
     </div>
)

export default InstructionStrip
